<template>
<v-card
    style="margin-bottom: 15px;"
    v-if="payment != null"
>
    
    <div
        class="void_label"
        v-if="payment != null && payment.state == 'void'"
    >
        VOID
    </div>

    <v-card-title>
        {{payment.created_for}} &mdash; {{payment.label}}

        <v-spacer/>
        
        <m-payment-chip-state
            :value="payment_state"
        />

        <v-menu 
            bottom 
            offset-y  
        >

            <template v-slot:activator="{ on }">
                
                <v-icon 
                    size="25"
                    v-on="on"
                    style="margin-left: 15px"
                >
                    mdi-dots-vertical
                </v-icon>
                
            </template>

            <v-list>
                <v-list-item
                    v-on:click="startVoid"
                >
                    <v-list-item-title>Void...</v-list-item-title>
                </v-list-item>

                <v-list-item
                    v-on:click="providePayment"
                >
                     <v-list-item-title>Provide payment information...</v-list-item-title>
                </v-list-item>

                 <v-list-item
                    v-on:click="providePaymentDevelopment"
                    v-if="development_payment_link != null"
                >
                     <v-list-item-title>DEVELOPMENT:  Provide payment information...</v-list-item-title>
                </v-list-item>

               

            </v-list>

        </v-menu> 
    </v-card-title>
    <v-card-text>

          <m-display-text
            label="Provide Payment Link"
            :value="payment.provide_payment_url"
            v-if="payment.state == 'open'"
          />

          <m-display-text
            label="Development Payment Link"
            :value="development_payment_link"
            v-if="payment.state == 'open' && development_payment_link != null"
          />

        
        <div
            v-if="payment.customer_endpoint_in_crms.length > 0"
            style="margin-top: -20px; margin-left: -10px;"
        >
            <v-chip
                v-for="(item, key) in payment.customer_endpoint_in_crms"
                :key="key"
                v-on="$rc.integrationSupports(item, 'customer-profile-link') ? { click: () => onClickOpenInCRM(item) } : {}"
                color="primary"
                class="ma-2"
                label
                small
            >
                {{$rc.pretty(item,'integration_name')}}
                <v-icon
                    v-if="$rc.integrationSupports(item, 'customer-profile-link')"
                    right
                    size="15"
                >
                    mdi-open-in-new
                </v-icon>
            </v-chip>
        </div>
        
        <m-card-property
            text="Description"
            v-if="payment.payment.request.description != null"
            :value="$rc.htmlLinebreak(payment.payment.request.description)"
        />

        
        <m-card-property
            text="Creation Time"
            :value="''+new Date(payment.request_created_time)"
        />

        <m-card-property
            text="Created By"
            :value="payment.request_created_by_employee_username"
        />

        <m-card-property
            text="Invoice Number"
            v-if="payment.request_invoice_number != null"
            :value="payment.request_invoice_number"
        />

        <m-card-property
            text="Amount"
            :value="pretty_print_amount_or_for_message"
        />

        <m-card-property
            text="Age Verification Received"
            v-if="has_age_verification_required_and_received"
            :value="age_verification_provided_text"
        />

        <m-card-property
            text="Name on Card"
            v-if="has_credit_card"
            :value="credit_card_name"
        />

        <div
            v-if="has_credit_card"
            style="display: flex"
        >
            <div
                style="margin-right: 15px;"
                v-if="issuer_logo != null"
            >
                <img 
                    :src="issuer_logo" 
                    width="80"
                    
                />
            </div>
            <div
            >
                <m-card-property
                    text="Credit Card Number"
                    :value="credit_card_number"
                />    
            </div>
            
        </div>


        <m-card-property
            text="Security Code"
            v-if="has_ccv"
            :value="ccv"
        />

        <m-card-property
            text="Expiration Date"
            v-if="has_credit_card"
            :value="credit_card_ex_date"
        />

        <m-card-property
            text="ACH Account Type"
            v-if="has_ach_account_type"
            :value="ach_account_type"
        />

        <m-card-property
            text="Bank Name"
            v-if="has_ach_bank_name"
            :value="ach_bank_name"
        />

        <m-card-property
            text="Routing Number"
            v-if="has_ach_routing_number"
            :value="ach_routing_number"
        />

        <m-card-property
            text="Account Number"
            v-if="has_ach_account_number"
            :value="ach_account_number"
        />

        <m-card-property
            text="Account Holder Name"
            v-if="has_ach_account_holder_name"
            :value="ach_account_holder_name"
        />

        <m-card-property
            text="Billing Zip / Postal Code"
            v-if="has_credit_card"
            :value="credit_card_billing_zip"
        />


        <m-card-property
            text="Email Address"
            v-if="has_email_address"
            :value="email_address"
        />

        <m-card-property
            text="Phone Number"
            v-if="has_phone_number"
            :value="phone_number"
        />

        <m-card-property
            text="Shipping Address"
            v-if="has_shipping_address"
            :value="shipping_address"
        />

        <m-card-property
            text="Billing Address"
            v-if="has_billing_address"
            :value="billing_address"
        />


        <m-card-property
            v-for="(item, index) in payment.payment.extra_fields"
            :key="'ex_field_'+index"
            :text="item.text"
            :value="item.value"
        />

        

        <!-- Processing Info -->
        <div
            v-if="payment.state == 'processed'"
        >

            <m-card-property
                text="Processed Time"
                v-if="payment.processed_time != null"
                :value="''+new Date(payment.processed_time)"
            />

            <m-card-property
                text="Processed By"
                v-if="payment.processed_by_employee_username != null"
                :value="payment.processed_by_employee_username"
            />

            <m-card-property
                text="Processing Result"
                v-if="payment.processing_result != null"
                :value="payment.processing_result == 'success' ? 'Success' : 'Failed'"
            />

            <m-card-property
                text="Processing Notes"
                v-if="payment.processed_notes != null"
                :value="payment.processed_notes"
            />

        </div>



        <!-- OPEN --> 
        <m-display-text
            label="Custom Thank You URL"
            :value="payment.payment.request.url_thank_you"
            v-if="payment.state == 'open' && payment.payment.request.url_thank_you != null"
        />


        <div
            style="text-align: center; font-weight: bold;"
            v-if="payment.state == 'open'"
        >

            <v-divider 
                light
                style="margin-bottom: 10px;"
            >
            </v-divider>

            Awaiting Customer Response
        </div>

        <!-- READY TO PROCESS -- no permissions -->
        <div
            v-if="payment.state == 'ready-to-process' && !can_process"
            style="text-align: center; font-weight: bold;"
        >
            <v-divider 
                light
                style="margin-bottom: 10px;"
            >
            </v-divider>

            Ready to Process<br/>
            <div style="font-size: 9px; margin-top: -5px;">({{unable_to_process_message}})</div>
        </div>



        <!-- READY TO PROCESS -->
        <div
            v-if="payment.state == 'ready-to-process' && can_process"
            style="text-align: right;"
        >
            
            <v-btn
                color="primary"
                v-if="process_state == 'not-started'"
                v-on:click="onStartProessing"
            >
                Reveal payment information for processing
            </v-btn>
                

            <v-text-field
                label="Notes"
                v-model="processing_notes"
                v-if="process_state == 'started'"
                autocomplete="off"
            />

            <v-btn
                v-if="process_state == 'started'"
                v-on:click="process_state = 'not-started'"
                style="margin-right: 15px"
            >
                Cancel
            </v-btn>

            <v-btn
                v-if="process_state == 'started'"
                v-on:click="onProcessFailed"
                style="margin-right: 15px"
            >
                Failed
            </v-btn>

            <v-btn
                color="primary"
                v-if="process_state == 'started'"
                v-on:click="onProcessSuccess"
            >
                Success
            </v-btn>

        </div>

    </v-card-text>

    
</v-card>
</template>

<script>
const E164 = require('@/js/E164.js');
export default {
    props: {
        payment: {
            type: Object,
            default: function() { return null; }
        },
    },

    data() {
        return {
            process_state: 'not-started',
            processing_notes: null,
        }
    },

    methods: {
        pretty_print_address(address) {
            let ret = address.address_line1;
            if ( address.address_line2 != null ) ret += "<br/>"+address.address_line2;
            if ( address.address_line3 != null ) ret += "<br/>"+address.address_line3;

            ret +=  "<br/>"+address.city+", "+address.state+" "+address.postal_code;

            if ( address.country != 'US' ) ret += "<br/>"+address.country;

            return ret;
        },

        onStartProessing()
        {
            this.processing_notes = null;
            this.$rc.showSpinner();

            this.$rc.getPayment(
                this.payment.payment_id,
                'get-full',

                (data) => {
                    this.$rc.hideSpinner();
                    this.payment.payment = data.payment;
                    this.process_state = 'started';
                    this.$forceUpdate();
                },

                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error', 'Unable to process payment');
                }
            );
        },

        onProcessFailed()
        {
            this.$rc.confirm(
                'Confirm Payment Failed',
                'This payment will be considered Processed, marked as Failed, and <b>the full credit card number will be permanently deleted</b> when you click "Failed" below.  You\'ll only be able to view the last four digits of this card in the future.',
                [
                    {'text' : 'Cancel', 'value' : 'cancel' },
                    {'text' : 'Failed', 'value' : 'confirmed' },
                ],

                (response) => {
                    if ( response != 'confirmed' ) return;
                    
                    this.processPayment('failed');
                }
            );
        },

        onProcessSuccess() 
        {
            this.$rc.confirm(
                'Confirm Payment Succeeded',
                'This payment will be considered Processed, marked as Processed, and <b>the full credit card number will be permanently deleted</b> when you click "Succeeded" below. You\'ll only be able to view the last four digits of this card in the future.',
                [
                    {'text' : 'Cancel', 'value' : 'cancel' },
                    {'text' : 'Succeeded', 'value' : 'confirmed' },
                ],

                (response) => {
                    if ( response != 'confirmed' ) return;
                    
                    this.processPayment('success');
                }
            );
        },

        processPayment(result)
        {
            let post_data = {
                'result' : result,
                'notes' : this.processing_notes,
            };

            this.$rc.showSpinner();

            this.$rc.processPayment(
                this.payment.payment_id,
                post_data,

                () => {
                    this.$rc.hideSpinner();
                    this.$rc.snackbar('Payment processed',3500);
                    this.afterProcessRefreshPayment();
                },

                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Unable to process payment', 'An error occoured while processing payment.  No changes have been made.');
                    this.process_state = 'not-started';
                },
            );
        },

        startVoid()
        {
            this.$rc.confirm(
                'Confirm Void Payment',
                'This payment will be considered and marked as Void, and <b>the full credit card number will be permanently deleted</b> when you click "Void" below.  You\'ll only be able to view the last four digits of this card in the future.',
                [
                    {'text' : 'Cancel', 'value' : 'cancel' },
                    {'text' : 'Void', 'value' : 'confirmed' },
                ],

                (response) => {
                    if ( response != 'confirmed' ) return;
                    
                    this.doVoidPayment();
                }
            );
        },

        doVoidPayment()
        {
            this.$rc.showSpinner();

            this.$rc.voidPayment(
                this.payment.payment_id,

                () => {
                    this.$rc.hideSpinner();
                    this.$rc.snackbar('Payment voided',3500);
                    this.afterProcessRefreshPayment();
                },

                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Unable to void payment', 'An error occoured while voiding payment.  No changes have been made.');
                    this.process_state = 'not-started';
                },
            );
        },

        afterProcessRefreshPayment()
        {
            this.process_state = 'not-started';
            this.processing_notes = null;

            this.$rc.getPayment(
                this.payment.payment_id,
                'get',

                (data) => {
                    this.$rc.hideSpinner();
                    this.payment.payment = data.payment;
                    this.$forceUpdate();

                    this.$emit('changed');
                },

                () => {
                    this.$rc.hideSpinner();
                }
            );
        },

        providePayment()
        {
            let route_data = this.payment.provide_payment_url;
            window.open(route_data, '_blank');
        },

        providePaymentDevelopment()
        {
            let route_data = this.development_payment_link;
            window.open(route_data, '_blank');
        },

        onClickOpenInCRM(crm_name)
        {
            this.$rc.showSpinner();

            let endpoint_one = this.payment.payment.request.response_send_by_endpoint;
            let endpoint_two = this.$rc.getDeep(this.payment, 'payment/customer_payment_info/payment_info_credit_card/phone_number');

            let endpoints = [];

            if ( endpoint_one != null ) endpoints.push(endpoint_one);
            if ( endpoint_two != null ) endpoints.push(endpoint_two);
            
            let params = {
                    'content_type' : crm_name,
                    'organization_id' : this.payment.organization_id,
                    'endpoint' : endpoints,
                };

            this.$rc.rest(
                'LIST: /api/v1/integrations/crm/customers/from-endpoint',
            
                params,
            
                (data) => {
                    this.$rc.hideSpinner();

                    let results = data.results;
                    if ( results.length == 0 )
                    {
                        this.$rc.alert('Error','No customer for this payment exists in '+crm_name);
                        return;
                    }

                    window.open(results[0].url_view_customer_in_crm);
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to search '+crm_name+' customers');
                },
            );
        },
    },

    computed: {
        pretty_print_amount_or_for_message() {
            if (this.payment.for_message != null && this.payment.for_message != '')
            {
                return this.payment.for_message;
            }

            if ( this.payment == null || this.payment.payment == null || this.payment.payment.request == null) return '';

            let ret = this.payment.payment.request.amount_pretty_print;
            return ret;
        },

        min_age_in_years()
        {
            if ( this.payment == null ) return 21;
            if ( this.payment.payment == null ) return 21;
            if ( this.payment.payment.request == null ) return 21;
            if ( this.payment.payment.request.min_age_in_years == null ) return 21;

            return this.payment.payment.request.min_age_in_years;
        },

        age_verification_provided_text() {

            if ( !this.has_age_verification_required_and_received ) return '';

            if ( this.payment.age_verification_requirement == 'checkbox' )
            {
                return 'Affirmation Checked (over the age of '+this.min_age_in_years+')';
            }

            // if here, it's birthdate
            let payment = this.payment.payment;

            if ( payment.customer_payment_info == null ) return '';

            let provided_text = payment.customer_payment_info.age_verification_provided_text;

            if ( provided_text == null ) return '';

            return 'Date of Birth Provided: ' + provided_text;
        },

        has_age_verification_required_and_received() {
            let payment = this.payment;
            if ( payment.age_verification_requirement == null || payment.age_verification_requirement == '' ) return false;

            if ( payment.age_verification_requirement == 'none' ) return false;

            // if haven't received customer info, don't show this portion
            if ( this.payment.payment.customer_payment_info == null ) return false;

            return true;
        },

        credit_card_name() {
            let payment = this.payment.payment;
            return payment.customer_payment_info.payment_info_credit_card.name_on_card;
        },

        has_credit_card() {
            let payment = this.payment.payment;
            if ( payment.customer_payment_info == null ) return false;
            if ( payment.customer_payment_info.payment_info_credit_card == null ) return false;
            return true;
        },

        credit_card_number() {
            let payment = this.payment.payment;
            let cc_info = payment.customer_payment_info.payment_info_credit_card;

            if ( cc_info.card_number != null )
            {
                return cc_info.card_number;
            }

            return 'x'+cc_info.card_number_last_four_digits;
        },

        has_ccv() {
            let payment = this.payment.payment;
            if ( payment.customer_payment_info == null ) return false;
            if ( payment.customer_payment_info.payment_info_credit_card == null ) return false;

            let cc_info = payment.customer_payment_info.payment_info_credit_card;

            return cc_info.card_number != null;
        },

        ccv() {
            let payment = this.payment.payment;
            let cc_info = payment.customer_payment_info.payment_info_credit_card;

            if ( cc_info.card_number != null )
            {
                return cc_info.ccv;
            }

            return 'xxx';
        },

        has_ach_account_type()
        {
            return this.$rc.getDeep(this.payment, 'payment/customer_payment_info/payment_info_ach/account_type') != null;
        },

        ach_account_type()
        {
            return this.$rc.getDeep(this.payment, 'payment/customer_payment_info/payment_info_ach/account_type');
        },

        has_ach_routing_number()
        {
            return this.$rc.getDeep(this.payment, 'payment/customer_payment_info/payment_info_ach/routing_number') != null;
        },

        ach_routing_number()
        {
            return this.$rc.getDeep(this.payment, 'payment/customer_payment_info/payment_info_ach/routing_number');
        },

        has_ach_bank_name()
        {
            return this.$rc.getDeep(this.payment, 'payment/customer_payment_info/payment_info_ach/bank_name') != null;
        },

        ach_bank_name()
        {
            return this.$rc.getDeep(this.payment, 'payment/customer_payment_info/payment_info_ach/bank_name');
        },

        has_ach_account_number()
        {
            return this.$rc.getDeep(this.payment, 'payment/customer_payment_info/payment_info_ach/account_number_last_four_digits') != null;
        },

        ach_account_number()
        {
            let account_number_last_four_digits = this.$rc.getDeep(this.payment, 'payment/customer_payment_info/payment_info_ach/account_number_last_four_digits');
            let account_number = this.$rc.getDeep(this.payment, 'payment/customer_payment_info/payment_info_ach/account_number');

            if ( account_number != null )
                return account_number;

            return 'x'+account_number_last_four_digits;
        },

        has_ach_account_holder_name()
        {
            return this.$rc.getDeep(this.payment, 'payment/customer_payment_info/payment_info_ach/account_holder_name') != null;
        },

        ach_account_holder_name()
        {
            return this.$rc.getDeep(this.payment, 'payment/customer_payment_info/payment_info_ach/account_holder_name');
        },

        credit_card_ex_date() {
            let payment = this.payment.payment;
            return payment.customer_payment_info.payment_info_credit_card.expiration_month + ' '+ payment.customer_payment_info.payment_info_credit_card.expiration_year;
        },

        credit_card_billing_zip() {
            let payment = this.payment.payment;
            return payment.customer_payment_info.payment_info_credit_card.billing_zip_code;
        },

        has_billing_address() {
            let payment = this.payment.payment;
            if ( payment.customer_payment_info == null ) return false;
            return payment.customer_payment_info.billing_address != null;
        },

        billing_address() {
            let payment = this.payment.payment;
            let address = payment.customer_payment_info.billing_address;

            return this.pretty_print_address(address);
        },

        has_shipping_address() {
            let payment = this.payment.payment;
            if ( payment.customer_payment_info == null ) return false;
            return payment.customer_payment_info.shipping_address != null;
        },

        shipping_address() {
            let payment = this.payment.payment;
            let address = payment.customer_payment_info.shipping_address;

            return this.pretty_print_address(address);
        },

        payment_state() {
            let payment = this.payment;
            if ( payment.state != 'processed') return payment.state;

            if ( payment.processing_result == 'failed' ) return 'processed-error';
            if ( payment.processing_result == 'success' ) return 'processed-success';

            return 'unknown';
        },

        has_email_address()
        {
            let one = this.$rc.$state.getDeep(this.payment, 'payment/customer_payment_info/payment_info_credit_card/email_address');
            let two = this.$rc.$state.getDeep(this.payment, 'payment/customer_payment_info/payment_info_ach/email_address');

            return one != null || two != null;
        },

        has_phone_number()
        {
            let one = this.$rc.$state.getDeep(this.payment, 'payment/customer_payment_info/payment_info_credit_card/phone_number');
            let two = this.$rc.$state.getDeep(this.payment, 'payment/customer_payment_info/payment_info_ach/phone_number');

            return one != null || two != null;
        },

    
        email_address()
        {
            let one = this.$rc.$state.getDeep(this.payment, 'payment/customer_payment_info/payment_info_credit_card/email_address');
            let two = this.$rc.$state.getDeep(this.payment, 'payment/customer_payment_info/payment_info_ach/email_address');

            if ( one != null ) return one;
            if ( two != null ) return two;

            return null;
        },

        phone_number()
        {
            let one = this.$rc.$state.getDeep(this.payment, 'payment/customer_payment_info/payment_info_credit_card/phone_number');
            let two = this.$rc.$state.getDeep(this.payment, 'payment/customer_payment_info/payment_info_ach/phone_number');

            if ( one != null ) return E164.prettyPrintUsPhoneNumberNoParens(one);
            if ( two != null ) return E164.prettyPrintUsPhoneNumberNoParens(two);

            return null;
        },

        can_process() {
            if (this.$rc.$state.profile.employee_account.payment_permissions == 'request-and-process')
            {
                return true;
            }

            if ( this.$rc.$state.profile.employee_account.payment_permissions == 'request-and-self-process' &&
                this.payment.request_created_by_employee_id == this.$rc.$state.profile.employee_account.employee_id)
            {
                return true;
            }

            return false;
        },

        unable_to_process_message()
        {
            if ( this.$rc.$state.profile.employee_account.payment_permissions == 'request-and-self-process' &&
                this.payment.request_created_by_employee_id != this.$rc.$state.profile.employee_account.employee_id)
            {
                return "can't process payments created by others";
            }

            return "you do not have permission to process";
        },

        development_payment_link()
        {
            let payment_url = this.$rc.getDeep(this.payment, 'provide_payment_url');
            if ( payment_url == null ) return null;
            if ( !payment_url.includes('front-end-redchirp.ngrok.io') ) return null;

            return 'http://127.0.0.1:8081/app/pay/'+this.payment.payment_id;
        },

        issuer_logo()
        {
            if ( this.payment == null ) 
                return null;

            if ( this.payment.state == 'void' || this.payment.state == 'processed' )
                 return null;
            
            let issuer = this.$rc.getDeep(this.payment, "payment/customer_payment_info/payment_info_credit_card/issuer");
            if ( issuer == null ) return null;

            return '/app/payment-method-logos/'+issuer+".svg";
        }

    },
}
</script>

<style lang="scss" scoped>

.void_label
{
    position: absolute; 
    left: 0px; 
    right: 0px; 
    top: 0px; 
    bottom: 0px; 
    text-align: center; 
    font-size: 100px; 
    color: rgba(0,0,0,0.15);
    display:flex;
    justify-content:center;
    align-items:center; 
}
</style>